// packages/utils/logout-helper.ts
'use client';
import Cookies from 'js-cookie';
// import axiosClient from '../api/src/axiosClient';
import axiosClient from '../../api/src/axiosClient';
import axiosInternal  from '../../api/src/axiosInternal';
import ssoClient  from '../../api/src/ssoClient2';

// ============================================
// Customer Logout
// ============================================
export async function logoutCustomer(options?: {
  redirect?: boolean;
  redirectTo?: string;
}) {
  try {
    //remove customer_session cookie
    // await axiosInternal.post('/api/auth/u-logout');
    // ✅ اول فراخوانی API logout (برای پاک کردن کوکی‌های httpOnly)
    await ssoClient.post('/auth/u-logout');
    Cookies.remove('token', { path: '/' });
    Cookies.remove('customer_session', { path: '/' });
    Cookies.remove('admin_session', { path: '/' });
    Cookies.remove('session_id', { path: '/' });
    Cookies.remove('csrftoken', { path: '/' });
    // ✅ پاک کردن localStorage
    if (typeof window !== 'undefined') {
      localStorage.removeItem('cart');
      localStorage.removeItem('wishlist');
      localStorage.setItem('logout-event', Date.now().toString());
    }
    
  } catch (err) {
    console.error('❌ Error during logout:', err);
  }
  
  // ✅ Redirect
  if (options?.redirect !== false && typeof window !== 'undefined') {
    const loginUrl = options?.redirectTo || '/login';
    window.location.href = loginUrl;
  }
}

// ============================================
// Admin Logout
// ============================================
export async function logoutAdmin(options?: {
  redirect?: boolean;
  redirectTo?: string;
}) {
  try {
    await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include',
    });
    
    Cookies.remove('token', { path: '/' });
    Cookies.remove('admin_session', { path: '/' });
    Cookies.remove('user_session', { path: '/' });
    Cookies.remove('customer_session', { path: '/' });
    
    if (typeof window !== 'undefined') {
      localStorage.setItem('logout-event', Date.now().toString());
    }
  } catch (err) {
    console.error('❌ Error during admin logout:', err);
  }
  
  if (options?.redirect !== false && typeof window !== 'undefined') {
    const loginUrl = options?.redirectTo || '/auth/login';
    window.location.href = loginUrl;
  }
}

// ============================================
// Shop Admin Logout
// ============================================
export async function logoutShopAdmin(options?: {
  redirect?: boolean;
  redirectTo?: string;
}) {
  try {

    //remove admin_session cookie
    await axiosInternal.post('/api/auth/ad-logout');

    await fetch('/api/auth/logout', {
      method: 'POST',
      credentials: 'include',
    });
    
    Cookies.remove('token', { path: '/' });
    Cookies.remove('shop_admin_session', { path: '/' });
    Cookies.remove('admin_session', { path: '/' });
    Cookies.remove('customer_session', { path: '/' });
    
    if (typeof window !== 'undefined') {
      localStorage.setItem('logout-event', Date.now().toString());
    }
  } catch (err) {
    console.error('❌ Error during shop admin logout:', err);
  }
  
  if (options?.redirect !== false && typeof window !== 'undefined') {
    const loginUrl = options?.redirectTo || '/auth/login';
    window.location.href = loginUrl;
  }
}

// ============================================
// Generic Logout (Legacy)
// ============================================
export async function logoutUser(options?: {
  redirect?: boolean;
  redirectTo?: string;
}) {
  return logoutCustomer(options);
}